module.exports = __webpack_public_path__ + "static/media/mitch-portrait.e8504e56.png";